import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('ancillary_rate_factor_set', '/ancillary_rate_factor_sets')
const reducer = generator.generate()

export default reducer
